import { useIntl } from "react-intl";
import { useProperty } from "../../components/property-provider";
import React, { useCallback, useMemo } from "react";
import { getEngineAppearance, updateEngineAppearance } from "./infrastructure/engineAppearance.api";
import CrudForm, { FormConfiguration } from "../shared/crud/form";
import schema from "./infrastructure/advancedEngineAppearance.schema.json";
import actions from "../../lib/actions";
import { withAuthorizationVerifier } from "../../components/authorization-verifier";
import { v4 as uuidv4 } from "uuid";
import { defaultCrudMessages } from "../shared/crud/simple-crud";
import { engineAppearanceMessages } from "./messages";
import { EngineAppearanceEntity } from "./domain/engineAppearance.entity";
import { JsonEditor } from "../shared/widgets/jsonEditor";

export interface AdvancedEngineAppearanceEntity {
  id: string;
  serialized: any;
}

const messages = {
  ...defaultCrudMessages,
  ...engineAppearanceMessages,
};
function buildFormConfiguration(): FormConfiguration<AdvancedEngineAppearanceEntity> {
  return {
    __fieldOrder: ["serialized", "*"],
    __useProtoStyleArrays: true,
    id: {
      default: () => uuidv4(),
      hidden: true,
    },
    serialized: {
      fieldWidget: JsonEditor,
      messages: {
        label: messages.engineAppearanceJsonLabel,
        helpText: messages.engineAppearanceJsonHelpText,
      },
    },
  };
}
function AdvancedEngineAppearanceForm() {
  const intl = useIntl();
  const propertyInfo = useProperty();
  const handleGetOne = useCallback(async () => {
    const simpleEngineAppearance = await getEngineAppearance(propertyInfo.token);
    return {
      id: simpleEngineAppearance.id,
      serialized: simpleEngineAppearance,
    };
  }, [propertyInfo.token]);

  const handleUpdate: (entity: AdvancedEngineAppearanceEntity) => Promise<void> = useCallback(
    async entity => {
      await updateEngineAppearance(entity.serialized as EngineAppearanceEntity, propertyInfo.token);
      alert(intl.formatMessage(messages.saveSuccess));
      return;
    },
    [intl, propertyInfo.token]
  );
  const formConfiguration = useMemo(() => buildFormConfiguration(), []);

  return (
    <CrudForm<AdvancedEngineAppearanceEntity>
      id={"advancedEngineAppearance"}
      schema={schema}
      formConfiguration={formConfiguration}
      messages={messages}
      onGet={handleGetOne}
      onUpdate={handleUpdate}
      canUpdate={actions.ModifyAppeareanceSettings}
      enumsOptional
    />
  );
}

export default withAuthorizationVerifier(AdvancedEngineAppearanceForm);
